"use client";

import { useTranslations } from "next-intl";

import { BagIcon } from "~/components/icons/bag-icon";
import { useCart } from "~/lib/use-cart";
import { Link } from "~/navigation";

export function Cart() {
  const { cart } = useCart();
  const t = useTranslations("Accessibility");
  const items = cart?.cartLines ?? [];
  return (
    <Link href="/checkout" className="flex items-center gap-1">
      <BagIcon empty={items.length === 0} />{" "}
      <span className="sr-only">{t("cart")}</span>
    </Link>
  );
}
